import React from 'react';
import { Search } from 'lucide-react';
import { Input } from '@/race-tracker/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/race-tracker/components/ui/select';

export default function StationFilters({ search, onSearchChange, filters, onFilterChange, stateOptions, marketOptions, affiliateOptions, repFirmOptions }) {
  return (
    <div className="space-y-3">
      {/* Search */}
      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
        <Input
          placeholder="Search stations, markets, states, affiliates…"
          value={search}
          onChange={e => onSearchChange(e.target.value)}
          className="pl-9 bg-card"
        />
      </div>

      {/* Filter dropdowns */}
      <div className="flex flex-wrap gap-2">
        <FilterSelect
          label="State"
          value={filters.State}
          options={stateOptions}
          onChange={v => onFilterChange('State', v)}
        />
        <FilterSelect
          label="Market"
          value={filters.Market}
          options={marketOptions}
          onChange={v => onFilterChange('Market', v)}
        />
        <FilterSelect
          label="Affiliate"
          value={filters.Affiliate}
          options={affiliateOptions}
          onChange={v => onFilterChange('Affiliate', v)}
        />
        <FilterSelect
          label="Rep Firm"
          value={filters['Rep Firm']}
          options={repFirmOptions}
          onChange={v => onFilterChange('Rep Firm', v)}
        />
      </div>
    </div>
  );
}

function FilterSelect({ label, value, options, onChange }) {
  return (
    <Select value={value || '_all_'} onValueChange={v => onChange(v === '_all_' ? '' : v)}>
      <SelectTrigger className="w-40 h-8 text-xs bg-card">
        <SelectValue placeholder={label} />
      </SelectTrigger>
      <SelectContent className="max-h-60">
        <SelectItem value="_all_">All {label}s</SelectItem>
        {options.map(opt => (
          <SelectItem key={opt} value={opt}>{opt}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}